
import { defineComponent } from "vue";
import Cronometro from './Cronometro.vue';

export default defineComponent({
  name: "Temporizador",
  components: {
    Cronometro
  },
  data() {
    return {
      tempoEmSegundos: 0,
      cronometro: 0,
      cronometroRodando: false
    };
  },

  methods: {
    iniciar() {
      this.cronometroRodando = true;
      this.cronometro = setInterval(() => {
        this.tempoEmSegundos++;
      }, 1000);
    },
    finalizar() {
      this.cronometroRodando = false;
      clearInterval(this.cronometro);
      this.$emit('aoTemporizadoFinalizado', this.tempoEmSegundos);
      this.tempoEmSegundos = 0;
    },
  },
  emits: ['aoTemporizadoFinalizado']
});
